import ReportSchedule from "../../components/report/report-schedule";

function ReportsPage() {

    return <ReportSchedule />;
}

export default ReportsPage;